import * as React from 'react';

const PATREON_LINK = 'https://www.patreon.com/chaoticrecode';

export const PatreonLink = () => (
    <a className={'patreon-link'} href={PATREON_LINK}>Patreon</a>
);
